module.exports = __webpack_public_path__ + "img/go_live_shop_small.8162e1d7.svg";